export default __webpack_public_path__ + "static/media/ToolbeltIcons_Artboard_19.39600c0d.png";